import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { USER_TOKEN_STORAGE_KEY, ANONYMOUS_TOKEN_STORAGE_KEY } from '../constants';
import { OidcToken } from '../tokens';
import { SessionStorage } from './SessionStorage';
export class CombinedSessionItem {
  constructor() {
    _defineProperty(this, "storage", new SessionStorage());
  }
  static hasTokenExpired(tokenData) {
    const expirationDate = Date.parse(tokenData.ExpirationDate);
    return expirationDate <= Date.now();
  }
  remove() {
    this.storage.removeItem(USER_TOKEN_STORAGE_KEY);
    this.storage.removeItem(ANONYMOUS_TOKEN_STORAGE_KEY);
    return this;
  }
  get() {
    const userToken = this.storage.getItem(USER_TOKEN_STORAGE_KEY);
    if (userToken && !CombinedSessionItem.hasTokenExpired(userToken)) {
      return userToken;
    }
    const anonymousToken = this.storage.getItem(ANONYMOUS_TOKEN_STORAGE_KEY);
    if (anonymousToken && !CombinedSessionItem.hasTokenExpired(anonymousToken)) {
      return anonymousToken;
    }
    return null;
  }
  set(value) {
    this.remove();
    const parsedToken = new OidcToken(value.Token);
    const customerId = parsedToken.getClaim('customer_id');
    const isUserSignedIn = typeof customerId === 'number' && customerId > 0;
    const key = isUserSignedIn ? USER_TOKEN_STORAGE_KEY : ANONYMOUS_TOKEN_STORAGE_KEY;
    this.storage.setItem(key, value);
    return this;
  }
}
//# sourceMappingURL=CombinedSessionItem.js.map